var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticStyle: { "padding-top": "30px" } }, [
      _c("div", { staticClass: "page-titles p-3 border-bottom" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-info btn-sm pull-right",
            on: {
              click: function ($event) {
                return _vm.$router.push("/account/users/general-partners")
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-list" }),
            _vm._v(" "),
            _c("span", { staticClass: "d-none d-sm-inline" }, [
              _vm._v("General partners"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("h3", { staticClass: "text-themecolor" }, [
          _vm._v(
            "Campaign setup (" +
              _vm._s(
                _vm.user.profile.first_name + " " + _vm.user.profile.last_name
              ) +
              ")"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container-fluid p-20",
          staticStyle: { "font-size": "0.75em" },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              (_vm.view == "emails" || _vm.view == "settings") &&
              !_vm.is_started
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-sm pull-right",
                      staticStyle: { "margin-top": "-20px" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.saveUserCampaign.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-save" }),
                      _vm._v("   "),
                      _c("span", { staticClass: "d-none d-sm-inline" }, [
                        _vm._v("Save and continue"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.view == "investors" && !_vm.is_started
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-sm pull-right",
                      staticStyle: { "margin-top": "-20px" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.saveUserCampaignInvestors.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-play" }),
                      _vm._v("   "),
                      _c("span", { staticClass: "d-none d-sm-inline" }, [
                        _vm._v("Start campaign"),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("ul", { staticClass: "pta-campaign-steps" }, [
                _c("li", { class: _vm.view == "emails" ? "active" : "" }, [
                  _vm._v("Emails"),
                ]),
                _vm._v(" "),
                _c("li", { class: _vm.view == "settings" ? "active" : "" }, [
                  _vm._v("Settings"),
                ]),
                _vm._v(" "),
                _c("li", { class: _vm.view == "investors" ? "active" : "" }, [
                  _vm._v("Investors"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _vm.view == "investors" && !_vm.is_started
                  ? _c("div", { staticClass: "card-body" }, [
                      !_vm.is_loaded
                        ? _c("div", [_vm._v("Data is loading ...")])
                        : _c("div", [
                            _vm.investors.length
                              ? _c("div", { staticClass: "table-responsive" }, [
                                  _vm.investors.length
                                    ? _c(
                                        "div",
                                        { staticClass: "table-responsive" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "pta-investor-selection",
                                              staticStyle: {
                                                "font-size": "24px",
                                              },
                                            },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass:
                                                    "table table-hover",
                                                  staticStyle: {
                                                    "max-width": "100%",
                                                  },
                                                },
                                                [
                                                  _vm._m(0),
                                                  _vm._v(" "),
                                                  _c(
                                                    "tbody",
                                                    _vm._l(
                                                      _vm.investors,
                                                      function (investor) {
                                                        return _vm.investors &&
                                                          investor.name
                                                          ? _c(
                                                              "tr",
                                                              {
                                                                class:
                                                                  investor.pivot
                                                                    .is_deactive ==
                                                                  2
                                                                    ? "pta-investor-deactivated"
                                                                    : "",
                                                              },
                                                              [
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    attrs: {
                                                                      valign:
                                                                        "top",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "input",
                                                                      {
                                                                        attrs: {
                                                                          type: "checkbox",
                                                                        },
                                                                        domProps:
                                                                          {
                                                                            value:
                                                                              investor.id,
                                                                            checked:
                                                                              investor
                                                                                .pivot
                                                                                .is_deactive ==
                                                                              2
                                                                                ? false
                                                                                : true,
                                                                          },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.updateInvestorStatus(
                                                                                investor.id,
                                                                                investor
                                                                                  .pivot
                                                                                  .is_deactive
                                                                              )
                                                                            },
                                                                        },
                                                                      }
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("td", {
                                                                  attrs: {
                                                                    valign:
                                                                      "top",
                                                                  },
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        investor.name
                                                                      ),
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c("td", {
                                                                  attrs: {
                                                                    valign:
                                                                      "top",
                                                                  },
                                                                  domProps: {
                                                                    innerHTML:
                                                                      _vm._s(
                                                                        investor.contact_person
                                                                      ),
                                                                  },
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "table-option",
                                                                  },
                                                                  [
                                                                    _vm.is_confirmed
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "btn-group",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "button",
                                                                              {
                                                                                directives:
                                                                                  [
                                                                                    {
                                                                                      name: "tooltip",
                                                                                      rawName:
                                                                                        "v-tooltip",
                                                                                      value:
                                                                                        "Message preview",
                                                                                      expression:
                                                                                        "'Message preview'",
                                                                                    },
                                                                                  ],
                                                                                staticClass:
                                                                                  "btn btn-info btn-sm",
                                                                                on: {
                                                                                  click:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      $event.preventDefault()
                                                                                      return _vm.showMessage(
                                                                                        investor.id
                                                                                      )
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fas fa-envelope",
                                                                                  }
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c("div", [
                                        _vm._v("No investors connected."),
                                      ]),
                                ])
                              : _vm._e(),
                          ]),
                    ])
                  : _vm.view == "emails" && _vm.is_loaded && !_vm.is_started
                  ? _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "pta-campaign-email" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Email 1"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.templateForm.message_1_subject,
                                  expression: "templateForm.message_1_subject",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                value: "",
                                name: "message_1_subject",
                              },
                              domProps: {
                                value: _vm.templateForm.message_1_subject,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.templateForm,
                                    "message_1_subject",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.templateForm,
                                "prop-name": "message_1_subject",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("autosize-textarea", {
                              attrs: { rows: "20", name: "message_1_body" },
                              model: {
                                value: _vm.templateForm.message_1_body,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.templateForm,
                                    "message_1_body",
                                    $$v
                                  )
                                },
                                expression: "templateForm.message_1_body",
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.templateForm,
                                "prop-name": "message_1_body",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pta-campaign-email" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Email 2"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.templateForm.message_2_subject,
                                  expression: "templateForm.message_2_subject",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                value: "",
                                name: "message_2_subject",
                              },
                              domProps: {
                                value: _vm.templateForm.message_2_subject,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.templateForm,
                                    "message_2_subject",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.templateForm,
                                "prop-name": "message_2_subject",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("autosize-textarea", {
                              attrs: { rows: "20", name: "message_2_body" },
                              model: {
                                value: _vm.templateForm.message_2_body,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.templateForm,
                                    "message_2_body",
                                    $$v
                                  )
                                },
                                expression: "templateForm.message_2_body",
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.templateForm,
                                "prop-name": "message_2_body",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pta-campaign-email" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Email 3"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.templateForm.message_3_subject,
                                  expression: "templateForm.message_3_subject",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                value: "",
                                name: "message_3_subject",
                              },
                              domProps: {
                                value: _vm.templateForm.message_3_subject,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.templateForm,
                                    "message_3_subject",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.templateForm,
                                "prop-name": "message_3_subject",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("autosize-textarea", {
                              attrs: { rows: "20", name: "message_3_body" },
                              model: {
                                value: _vm.templateForm.message_3_body,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.templateForm,
                                    "message_3_body",
                                    $$v
                                  )
                                },
                                expression: "templateForm.message_3_body",
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.templateForm,
                                "prop-name": "message_3_body",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pta-campaign-email" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Email 4"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.templateForm.message_4_subject,
                                  expression: "templateForm.message_4_subject",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                value: "",
                                name: "message_4_subject",
                              },
                              domProps: {
                                value: _vm.templateForm.message_4_subject,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.templateForm,
                                    "message_4_subject",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.templateForm,
                                "prop-name": "message_4_subject",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("autosize-textarea", {
                              attrs: { rows: "20", name: "message_4_body" },
                              model: {
                                value: _vm.templateForm.message_4_body,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.templateForm,
                                    "message_4_body",
                                    $$v
                                  )
                                },
                                expression: "templateForm.message_4_body",
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.templateForm,
                                "prop-name": "message_4_body",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pta-campaign-email" }, [
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Email 5"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.templateForm.message_5_subject,
                                  expression: "templateForm.message_5_subject",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                value: "",
                                name: "message_5_subject",
                              },
                              domProps: {
                                value: _vm.templateForm.message_5_subject,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.templateForm,
                                    "message_5_subject",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.templateForm,
                                "prop-name": "message_5_subject",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c("autosize-textarea", {
                              attrs: { rows: "20", name: "message_5_body" },
                              model: {
                                value: _vm.templateForm.message_5_body,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.templateForm,
                                    "message_5_body",
                                    $$v
                                  )
                                },
                                expression: "templateForm.message_5_body",
                              },
                            }),
                            _vm._v(" "),
                            _c("show-error", {
                              attrs: {
                                "form-name": _vm.templateForm,
                                "prop-name": "message_5_body",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm.view == "settings" && !_vm.is_started
                  ? _c("div", { staticClass: "card-body" }, [
                      _c("h3", [_vm._v("Email sending")]),
                      _vm._v(" "),
                      _c("label", [_vm._v("Sending interval: ")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.templateForm.sending_interval,
                              expression: "templateForm.sending_interval",
                            },
                          ],
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.templateForm,
                                "sending_interval",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v("1 day"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "2", selected: "" } },
                            [_vm._v("2 days")]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "5" } }, [
                            _vm._v("5 days"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "10" } }, [
                            _vm._v("10 days"),
                          ]),
                        ]
                      ),
                    ])
                  : _vm.is_started
                  ? _c("div", { staticClass: "card-body" }, [
                      _c("h3", [_vm._v("Campaign is running")]),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal fade", attrs: { id: "modalMessage" } }, [
      _c(
        "div",
        { staticClass: "modal-dialog", staticStyle: { "max-width": "920px" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "div",
              {
                staticClass: "modal-header",
                staticStyle: { display: "block" },
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "h4",
                  { staticClass: "modal-title", attrs: { id: "modalTitle" } },
                  [
                    _vm._v(
                      "Message preview (" + _vm._s(_vm.cur_message_name) + ")"
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal-body",
                staticStyle: { "font-size": "18px", "line-height": "24px" },
                attrs: { id: "modalBody" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "carousel slide",
                    attrs: {
                      id: "carouselExampleIndicators",
                      "data-ride": "carousel",
                    },
                  },
                  [
                    _c("ol", { staticClass: "carousel-indicators" }, [
                      _c("li", {
                        staticClass: "active",
                        attrs: {
                          "data-target": "#carouselExampleIndicators",
                          "data-slide-to": "0",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSlide(0)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("li", {
                        attrs: {
                          "data-target": "#carouselExampleIndicators",
                          "data-slide-to": "1",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSlide(1)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("li", {
                        attrs: {
                          "data-target": "#carouselExampleIndicators",
                          "data-slide-to": "2",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSlide(2)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("li", {
                        attrs: {
                          "data-target": "#carouselExampleIndicators",
                          "data-slide-to": "3",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSlide(3)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("li", {
                        attrs: {
                          "data-target": "#carouselExampleIndicators",
                          "data-slide-to": "4",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onSlide(4)
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _vm.messages[0]
                      ? _c("div", { staticClass: "carousel-inner" }, [
                          _c("div", {
                            staticClass: "carousel-item active",
                            domProps: {
                              innerHTML: _vm._s(_vm.messages[0].message),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "carousel-item",
                            domProps: {
                              innerHTML: _vm._s(_vm.messages[1].message),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "carousel-item",
                            domProps: {
                              innerHTML: _vm._s(_vm.messages[2].message),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "carousel-item",
                            domProps: {
                              innerHTML: _vm._s(_vm.messages[3].message),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "carousel-item",
                            domProps: {
                              innerHTML: _vm._s(_vm.messages[4].message),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "carousel-control-prev",
                        attrs: {
                          href: "#carouselExampleIndicators",
                          role: "button",
                          "data-slide": "prev",
                        },
                        on: { click: _vm.onSlidePrev },
                      },
                      [
                        _c("span", {
                          staticClass: "carousel-control-prev-icon",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Previous"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "carousel-control-next",
                        attrs: {
                          href: "#carouselExampleIndicators",
                          role: "button",
                          "data-slide": "next",
                        },
                        on: { click: _vm.onSlideNext },
                      },
                      [
                        _c("span", {
                          staticClass: "carousel-control-next-icon",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Next"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Organisation")]),
        _vm._v(" "),
        _c("th", [_vm._v("Contact Person")]),
        _vm._v(" "),
        _c("th", { staticClass: "table-option" }, [_vm._v("Mail-Preview")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: { type: "button", "data-dismiss": "modal" },
      },
      [
        _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")]),
        _vm._v(" "),
        _c("span", { staticClass: "sr-only" }, [_vm._v("close")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }